// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__CqZTm","info":"PatientInfo_info__33IUd"};